import React, { useEffect } from "react";
import ic_back from "../../../Resources/Images/ic_back.png";
import moment from "moment";
import "./Report.scss";
import { PATHS } from "../../../Constants";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import { Strings } from "../../../Resources/Strings/i18n";
// import { SUBSCRIPTION_PLANS } from "../../../Communication/Constants";
import Button from "@material-ui/core/Button";
import CommonUtils from "../../../Utils/CommonUtils";
import { connect } from "react-redux";
import DashBordAction from "../DashboardAction";
import { OperationStatus } from "../../../Communication/Constants";
import InstallAppModal from "../../InstallAppModal/InstallAppModal";
import ErrorModal from "../../Settings/ErrorModal/ErrorModal";
import SuccessModal from "../../SuccessModal/SuccessModal";
import CustomSpinner from "../../Spinner/Spinner";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { DEFAULT_PARAMETERS } from "../Constants";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import ManageReports from './ManageReports';

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));
function Report(props) {
  const [value, setValue] = React.useState(0);
  const [recipientName, setRecipientName] = React.useState("");
  const [recipientError, setRecipientError] = React.useState(false);
  const [recipientEmail, setRecipientEmail] = React.useState("");
  const [recipientEmailError, setRecipientEmailError] = React.useState(false);
  const [quickReport, setQuickReport] = React.useState(true);
  const [dayReport, setDayReport] = React.useState(false);
  const [weekReport, setWeekReport] = React.useState(false);
  const [monthReport, setMonthReport] = React.useState(false);
  const [openInstallApp, setOpenInstallApp] = React.useState(false);
  const [showErrorModal, setShowErrorModal] = React.useState(false);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [custSpinner, setcustSpinner] = React.useState(false);
  const [schedulePlan, setSchedulePlan] = React.useState(0);
  const [defaultDailyTime, setDefaultDailyTime] = React.useState(
    DEFAULT_PARAMETERS.defaultDailyTime
  );
  const [weekDay, setWeekDay] = React.useState(new Date().getDay());
  const [frequency, setFrequency] = React.useState("NOW");
  const [type, setType] = React.useState("IMMEDIATE");
  const [retrived, setRetrived] = React.useState(JSON.parse(localStorage.getItem("myState")));

  const clearData = () => {
    setRecipientName("");
    setRecipientError(false);
    setRecipientEmail("");
    setRecipientEmailError(false);
    setQuickReport(true);
    setDayReport(false);
    setWeekReport(false);
    setMonthReport(false);
  };

  const classes = useStyles();

  let dashBordAction = new DashBordAction();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let retrievedState = {};
  useEffect(() => {
    if (
      !props.userInfo ||
      !props.userInfo.accessToken ||
      !props.userInfo.id ||
      (props.inviteTokenInfo && props.inviteTokenInfo.isInvitedUser)
    ) {
      props.history && props.history.push(PATHS.HOME);
    }
  
    let myDataState = JSON.parse(localStorage.getItem("myDataState"));
    let myState = JSON.parse(localStorage.getItem("myState"));
    
    if (myState && myState !== null) {
      retrievedState = myState;
    }
    
    if (myDataState && myDataState !== null) {
      retrievedState = myDataState;
    }

    if (!retrievedState || !retrievedState.id) {
      props.history && props.history.push(PATHS.HOME);
    }
  }, [retrievedState]);

  const sendReportHandler = (recipientsparam) => {
    let isValid = true;

    let myDataState = JSON.parse(localStorage.getItem("myDataState"));
    let myState = JSON.parse(localStorage.getItem("myState"));
    let retrievedState1;
    if (myState && myState !== null) {
      retrievedState1 = myState;
    }
    
    if (myDataState && myDataState !== null) {
      retrievedState1 = myDataState;
    }

    // let retrievedState1 = JSON.parse(localStorage.getItem("myState"));
    let reqObj = {
      frequency: frequency,
      type: type,
    };
    if (value === 0) {
      if (!recipientName.trim().match(/^[a-zA-Z]+$/)) {
        setRecipientError(true);
        isValid = false;
        // return;
      }
      if (!CommonUtils.isEmailValid(recipientEmail.trim())) {
        setRecipientEmailError(true);
        isValid = false;
      }

      if (recipientsparam.type === "RECURRING") {
        if (schedulePlan === 0) {
          reqObj = {
            frequency: "DAILY",
            type: recipientsparam.type,
            time: moment(defaultDailyTime).format("HH:mm"),
            isResend:false,
          };
        } else if (schedulePlan === 1) {
          reqObj = {
            frequency: "WEEKLY",
            type: recipientsparam.type,
            time: moment(defaultDailyTime).format("HH:mm"),
            day: weekDay,
            isResend:false,
          };
        } else {
          reqObj = {
            frequency: "MONTHLY",
            type: recipientsparam.type,
            time: moment(defaultDailyTime).format("HH:mm"),
            isResend:false,
          };
        }
      }
    }

    if (isValid) {
      let requestData = {
        report_of: retrievedState1 && retrievedState1.id,
        recipients: [
          {
            recipient_name: recipientName,
            recipient_email: recipientEmail,
            reports: [reqObj],
          },
        ],
      };
      if(value === 1){
        requestData = {
          report_of: retrievedState1 && retrievedState1.id,
          recipients: recipientsparam
        };
      }
      setcustSpinner(true);
      dashBordAction.createReport(requestData, (actionCallback) => {
        console.log('requestData' + JSON.stringify(requestData))
        if (actionCallback.status === OperationStatus.SUCCESS) {
          setShowSuccessModal(true);
          setShowErrorModal(false);
          setErrorMessage("");
          setcustSpinner(false);
          clearData();
        } else {
        console.log('requestData ERROR:' + JSON.stringify(actionCallback.error))
          setShowErrorModal(true);
          setShowSuccessModal(false);
          setErrorMessage(actionCallback.error.errorMessage);
          setcustSpinner(false);
          clearData();
        }
      });
    }
  };

  return (
    <div className="ReportContainer">
      <CustomSpinner showModal={custSpinner} />

      {/* show Install App modal */}
      {openInstallApp && (
        <InstallAppModal
          openInstallApp={openInstallApp}
          hideModal={() => setOpenInstallApp(false)}
        />
      )}

      {/* success modal */}
      <div>
        {showSuccessModal ? (
          <SuccessModal
            showSuccessModal={showSuccessModal}
            SuccessMessage="Email report sent successfully"
            closeSuccessModal={() => setShowSuccessModal(false)}
          />
        ) : null}
      </div>

      {/* error modal */}
      <div>
        {showErrorModal ? (
          <ErrorModal
            showErrorModal={showErrorModal}
            errorMessage={errorMessage}
            history={props.history}
            setShowErrorModal={(value) => setShowErrorModal(value)}
          />
        ) : null}
      </div>

      <div
        className="NameDetails"
        onClick={() => {
          //   localStorage.removeItem("myState");
          props.history.push(PATHS.HOME + PATHS.LOVED_ONES);
        }}
      >
        <img src={ic_back} alt="ic_back" />
        {"Reports"}
      </div>
      <div className="tabsContainer">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="send" className="sendTab" />
          <Tab label="manage" className="manageTab" />
        </Tabs>
      </div>
      {!value 
        ?
        (
          <div>
            <div className="RecipientContainer">
              <div className="addRecipient">Add Recipient</div>
              <div className="recipientContainer">
                <form className={classes.root} noValidate autoComplete="off">
                  <TextField
                    className="RecipientName"
                    label="Recipient Name"
                    required
                    type="text"
                    autoComplete="off"
                    id="standard-basic"
                    name={Strings("RecipientName")}
                    value={recipientName}
                    error={recipientError}
                    onChange={(event) => setRecipientName(event.target.value)}
                    onFocus={() => {
                      setRecipientError(false);
                    }}
                  />
                  <TextField
                    className="RecipientEmail"
                    label="Recipient Email address"
                    required
                    type="email"
                    autoComplete="off"
                    id="standard-basic"
                    name={Strings("RecipientEmail")}
                    value={recipientEmail}
                    error={recipientEmailError}
                    onChange={(event) => setRecipientEmail(event.target.value)}
                    onFocus={() => {
                      setRecipientEmailError(false);
                    }}
                  />
                </form>
              </div>
            </div>
            <div className="selectReportContainer">
              <div className="addRecipient">Select Report</div>
              <div className="recipientContainer">
                <div className="phoneNotification">
                  <div className={quickReport ? "phoneNotif" : "textNotif"}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          icon={<RadioButtonUncheckedIcon />}
                          checkedIcon={<CheckCircleIcon />}
                          name="checkedB"
                          color="primary"
                          checked={quickReport}
                          onClick={() => {
                            setDayReport(false);
                            setWeekReport(false);
                            setMonthReport(false);
                            setQuickReport(true);
                            setFrequency("NOW");
                          }}
                        />
                      }
                      label={Strings("QuickSend")}
                    />
                  </div>
                  <div className={dayReport ? "phoneNotif" : "textNotif"}>
                    <div>
                      <FormControlLabel
                        control={
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<CheckCircleIcon />}
                            color="primary"
                            name="checkedB"
                            checked={dayReport}
                            onClick={() => {
                              if (
                                (retrievedState && retrievedState.plan === "PREMIUM") ||
                                (retrievedState && retrievedState.plan === "PRO-PREMIUM") ||
                                (retrievedState && retrievedState.plan === "BASIC") ||
                                (retrievedState && retrievedState.plan === "STANDARD") ||
                                (retrievedState && retrievedState.plan === "ADVANCED") ||
                                (retrievedState && retrievedState.plan === "FREE")
                              ) {
                                setQuickReport(false);
                                setWeekReport(false);
                                setMonthReport(false);
                                setDayReport(true);
                                setFrequency("DAILY");
                              } else {
                                //open installAppModal
                                // setOpenInstallApp(true);
                                setShowErrorModal(true);
                                setErrorMessage('Please upgrade to paid plans to use this feature.')
                                
                              }
                            }}
                          />
                        }
                        label={Strings("DailyCharts")}
                      />
                    </div>
                    <div className="plan">
                      {/* <span>{Strings("PLUS")}</span> */}
                      {/* {Strings("PREMIUM")} */}
                    </div>
                  </div>
                  <div className={weekReport ? "phoneNotif" : "textNotif"}>
                    <div>
                      <FormControlLabel
                        control={
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<CheckCircleIcon />}
                            color="primary"
                            name="checkedB"
                            checked={weekReport}
                            onClick={() => {
                              if (
                                retrievedState && (
                                (retrievedState.plan === "PREMIUM") || (retrievedState.plan === "PRO-PREMIUM") ||
                                (retrievedState.plan === "BASIC") || (retrievedState.plan === "STANDARD") ||
                                (retrievedState.plan === "ADVANCED") || (retrievedState.plan === "FREE"))
                              ) {
                                setDayReport(false);
                                setQuickReport(false);
                                setMonthReport(false);
                                setWeekReport(true);
                                setFrequency("WEEKLY");
                              } else {
                                //open installAppModal
                                setOpenInstallApp(true);
                              }
                            }}
                          />
                        }
                        label={Strings("WeeklyCharts")}
                      />
                    </div>

                    {/* <div className="plan">{Strings("PREMIUM")}</div> */}
                  </div>
                  <div className={monthReport ? "phoneNotif" : "textNotif"}>
                    <div>
                      <FormControlLabel
                        control={
                          <Checkbox
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<CheckCircleIcon />}
                            color="primary"
                            name="checkedB"
                            checked={monthReport}
                            onClick={() => {
                              if (
                                retrievedState && (
                                (retrievedState.plan === "PREMIUM") || (retrievedState.plan === "PRO-PREMIUM") ||
                                (retrievedState.plan === "BASIC") || (retrievedState.plan === "STANDARD") ||
                                (retrievedState.plan === "ADVANCED") || (retrievedState.plan === "FREE"))
                              ) {
                                setDayReport(false);
                                setWeekReport(false);
                                setMonthReport(true);
                                setQuickReport(false);
                                setFrequency("MONTHLY");
                              } else {
                                //open installAppModal
                                setOpenInstallApp(true);
                              }
                            }}
                          />
                        }
                        label={Strings("MonthlyCharts")}
                      />
                    </div>

                    {/* <div className="plan">{Strings("PREMIUM")}</div> */}
                  </div>
                </div>
              </div>
              <div className="sendReportButton">
                <Button
                  variant="contained"
                  color="primary"
                  // type="submit"
                  onClick={()=>{
                    sendReportHandler({type:"IMMEDIATE"})}}
                >
                  {Strings("SendReport")}
                </Button>
              </div>
            </div>
            <div className="ScheduleReportContainer">
              <div className="addRecipient">
                <span>Set a Schedule</span>
                {/* <span className="PremiumText">PREMIUM</span> */}
              </div>
              <div className="recipientContainer">
                <div className="phoneNotification">
                  <Tabs
                    value={schedulePlan}
                    onChange={(event, newValue) => {
                      setSchedulePlan(newValue);
                    }}
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="icon tabs example"
                  >
                    <Tab icon="daily" aria-label="phone" className="DailyBlock" />
                    <Tab
                      icon="weekly"
                      aria-label="favorite"
                      className="WeeklyBlock"
                    />
                    <Tab
                      icon="monthly"
                      aria-label="person"
                      className="MonthlyBlock"
                    />
                  </Tabs>
                </div>
                <div className="setScheduleContainer">
                  {schedulePlan === 0 && (
                    <div className="getTime">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardTimePicker
                          className="red"
                          expandicon={<ExpandMoreIcon />}
                          disabled={(retrived && retrived.plan === "PLUS") }

                          margin="normal"
                          id="time-picker"
                          label={Strings("Time")}
                          value={defaultDailyTime}
                          onChange={(date) => {
                            setDefaultDailyTime(date);
                          }}
                          KeyboardButtonProps={{
                            "aria-label": "change time",
                          }}
                          keyboardIcon={<AccessTimeIcon />}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  )}
                  {schedulePlan === 1 && (
                    <div className="weeklyTime">
                      <div className="RelationShipBlock">
                        {
                          <FormControl className="formControl">
                            <InputLabel htmlFor="age-native-simple">
                              {"Day"}
                            </InputLabel>
                            <Select
                              inputProps={{
                                name: "age",
                                id: "age-native-simple",
                              }}
                              value={weekDay}
                              onChange={(event) => {
                                setWeekDay(event.target.value);
                              }}
                              disabled={(retrived && retrived.plan === "PLUS") }
    
                            >
                              <MenuItem value={0}>Sunday</MenuItem>
                              <MenuItem value={1}>Monday</MenuItem>
                              <MenuItem value={2}>Tuesday</MenuItem>
                              <MenuItem value={3}>Wednesday</MenuItem>
                              <MenuItem value={4}>Thursday</MenuItem>
                              <MenuItem value={5}>friday</MenuItem>
                              <MenuItem value={6}>saturday</MenuItem>
                            </Select>
                          </FormControl>
                        }
                      </div>
                      <MuiPickersUtilsProvider
                        utils={DateFnsUtils}
                        className="weeklydaytime"
                      >
                        <KeyboardTimePicker
                          className="red"
                          expandicon={<ExpandMoreIcon />}
                          disabled={ (retrived && retrived.plan === "PLUS") }

                          margin="normal"
                          id="time-picker"
                          label={Strings("Time")}
                          value={defaultDailyTime}
                          onChange={(date) => {
                            setDefaultDailyTime(date);
                          }}
                          KeyboardButtonProps={{
                            "aria-label": "change time",
                          }}
                          keyboardIcon={<AccessTimeIcon />}
                        />
                      </MuiPickersUtilsProvider>
                    </div>
                  )}
                  {schedulePlan === 2 && (
                    <div className="getTime">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardTimePicker
                          className="red"
                          expandicon={<ExpandMoreIcon />}
                          disabled={(retrived && retrived.plan === "PLUS") }

                          margin="normal"
                          id="time-picker"
                          label={Strings("Time")}
                          value={defaultDailyTime}
                          onChange={(date) => {
                            setDefaultDailyTime(date);
                          }}
                          KeyboardButtonProps={{
                            "aria-label": "change time",
                          }}
                          keyboardIcon={<AccessTimeIcon />}
                        />
                      </MuiPickersUtilsProvider>
                      <div className="timeText">
                        Report will be sent on the 1st of next month
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="sendReportButton">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={ (retrived && retrived.plan === "PLUS") }

                  onClick={() => {
                    sendReportHandler({type:"RECURRING"});
                  }}
                >
                  {Strings("SaveAndSend")}
                </Button>
              </div>
            </div>
          </div>
        )
        :
        (
          <ManageReports
            dashBordAction={dashBordAction}
            openInstallApp={openInstallApp}
            setOpenInstallApp={setOpenInstallApp}
            setShowErrorModal={setShowErrorModal}
            setErrorMessage={setErrorMessage} 
            setcustSpinner={setcustSpinner}
            sendReportHandler={sendReportHandler}
          />
        )
      }
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userInfo: CommonUtils.getInvitedTokenInfo(state),
    userList: state.Dashboard.userInfo,
    summeryUserList: state.Dashboard.summeryUserList,
    invitedUserInfo: state.Dashboard.invitedUserInfo,
    inviteTokenInfo: state.InvitationHandler.accessInfo,
  };
}

export default connect(mapStateToProps, null)(Report);
